import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import AlertModal from '../../../shared/components/Modal';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useHistory } from "react-router-dom";

const ModalPaymentTypeUpdate = ({ doCloseModalPaymentType, opened, profesional, updatePaymentType }) => {
    const history = useHistory();

    const [typePayment, setTypePayment] = React.useState(null);
    const [fixedValue, setFixedValue] = React.useState(null);

    const [openModal, setOpenModal] = React.useState(opened);
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    React.useEffect(() => {
        if (profesional.tipo_pago != null && profesional.tipo_pago !== undefined) {
            setTypePayment(profesional.tipo_pago);
        }
        if (profesional.valor_fijo != null && profesional.valor_fijo !== undefined) {
            setFixedValue(profesional.valor_fijo);
        }          
    }, []);

    const addPaymentType = async () => {
        let dataPaymentType =
        {
            id_profesional: parseInt(profesional.id_profesional),
            tipo_pago: parseInt(typePayment),
            valor_fijo: parseInt(fixedValue)
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}profesional/actualizar-tipo-pago`, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataPaymentType)
        }).then(response => {
            response.json();
        }).then(data => {
            updatePaymentType(parseInt(typePayment));
            closeModal();
        }).catch(err => {
            alertModal(false, "Ha ocurrido un error en el sistema");
        });
    }

    const closeModal = () => {
        doCloseModalPaymentType();
    }

    React.useEffect(() => {

    }, []);

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Actualizar Tipo de Pago Profesional</h5>
                        </div>
                        <Row>
                            <Col md={6}>
                                <TextField
                                    label="Profesional"
                                    value={
                                        profesional.apellido2 != null ?
                                            profesional.nombres + ' ' + profesional.apellido1 + ' ' + profesional.apellido2 :
                                            profesional.nombres + ' ' + profesional.apellido1
                                    }
                                    disabled={true}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                            <Col md={6}>
                                <TextField
                                    select
                                    label="Tipo de Pago"
                                    value={typePayment}
                                    onChange={(event) => {
                                        setTypePayment(event.target.value);
                                    }}
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    <MenuItem key={1} value={1}>
                                        Por Servicio
                                    </MenuItem>
                                    <MenuItem key={2} value={2}>
                                        Por Valor Mensual
                                    </MenuItem>
                                </TextField>
                            </Col>
                            {
                                typePayment == 2 ?
                                <Col md={6}>
                                    <TextField
                                        type="number"
                                        label="Valor Mensual"
                                        value={fixedValue}
                                        onChange={(event) => {
                                            setFixedValue(event.target.value);
                                        }}
                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                        className="medical-material-form__field"
                                        InputLabelProps={{
                                            style: { color: '#646777' }
                                        }}
                                    />
                                </Col> : null
                            }



                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                addPaymentType();
                            }}
                        >
                            Guardar
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => setAlerShowModal(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default ModalPaymentTypeUpdate;
